import { InjectionToken } from '@angular/core';

export const WindowToken = new InjectionToken<Window>('window');

export function windowProvider() {
  return window;
}
